import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-feedback-execution-actions-modal',
    templateUrl: './feedback-execution-actions-modal.component.html'
})
export class FeedbackExecutionActionsModalComponent implements OnInit {
    actionType: any;
    jobMatchId: any;
    jobId: any;
    candidateId: any;
    feedbackType: any;
    scheduleId: any;
    feedbackUserIdsList: any;
    editFeedbackApprovalInfo: any;
    isJobProfileLoaded: boolean;
    callbackObject: any;
    title: any;
    workflowStep: any;
    public onClose: Subject<any>;

    constructor(
        private bsModalRef: BsModalRef,
        public bsModalService: BsModalService
    ) {
        this.onClose = new Subject();
    }

    ngOnInit(): void {
        const modalData: any = this.bsModalService.config.initialState || {};
        this.actionType = modalData.actionType;
        this.jobMatchId = modalData.jobMatchId;
        this.jobId = modalData.jobId;
        this.candidateId = modalData.candidateId;
        this.feedbackType = modalData.feedbackType;
        this.scheduleId = modalData.scheduleId;
        this.feedbackUserIdsList = modalData.feedbackUserIdsList;
        this.editFeedbackApprovalInfo = modalData.editFeedbackApprovalInfo;
        this.isJobProfileLoaded = false;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.title = this._getTitle();
        if (this.feedbackType === 'PhoneScreen') {
            this.workflowStep = 'ps';
        } else if (this.feedbackType === 'RecruiterScreening') {
            this.workflowStep = 'rs';
        } else {
            this.workflowStep = 'in';
        }
        setTimeout(() => {
            this.isJobProfileLoaded = true;
        }, 3000);
    }

    _getTitle() {
        if (this.actionType === 'candidateBooklet') {
            return 'Candidate Booklet';
        } else if (this.actionType === 'jobProfile') {
            return 'Job Profile';
        } else {
            return 'Feedback Edit Approval';
        }
    }

    closeModal(): void {
        this.onClose.next(this.callbackObject);
        this.bsModalRef.hide();
    }

    dismissModal(): void {
        this.bsModalRef.hide();
    }

    refresh(): void {
        this.callbackObject.callbackType = 'refresh';
        this.closeModal();
    }

    // Feedback edit approval/denial methods
    saveAndApproveFeedbackEdit(): void {
        this.callbackObject.callbackType = 'saveAndApproveFeedbackEdit';
        this.closeModal();
    }

    approveFeedbackEdit(): void {
        this.callbackObject.callbackType = 'approveFeedbackEdit';
        this.closeModal();
    }

    denyRequestToEditFeedback(): void {
        this.callbackObject.callbackType = 'denyFeedbackEdit';
        this.closeModal();
    }
}
